import {
  ComboboxItem,
  ComboboxItemGroup,
  Select as MantineSelect,
} from "@mantine/core";
import { ComponentProps, useState } from "react";

type SelectProps = ComponentProps<typeof MantineSelect>;

const hasGroup = (
  x: string | ComboboxItem | ComboboxItemGroup<string | ComboboxItem>,
) => {
  const maybeGroup = x as ComboboxItemGroup<string | ComboboxItem>;
  return !!maybeGroup.group;
};

/**
 * Provids a select element.
 *
 * This is a wrapper over Mantine's select: https://mantine.dev/core/select
 */
const Select = ({
  comboboxProps = { shadow: "xl" },
  ...props
}: SelectProps) => {
  /**
   * If the select is "searchable" we'll control the search value.
   * This allows us to clear the search when a user focuses the control.
   */
  const [search, setSearch] = useState(props.value ?? undefined);

  // we will tweak the styles of groups are present
  const hasGroups = props.data?.find(hasGroup);

  return (
    <MantineSelect
      classNames={
        hasGroups ? { option: "ps-4", groupLabel: "fs-6" } : undefined
      }
      searchValue={props.searchable ? search : undefined}
      onSearchChange={props.searchable ? (val) => setSearch(val) : undefined}
      onFocus={props.searchable ? () => setSearch("") : undefined}
      withScrollArea={false}
      styles={{ dropdown: { maxHeight: 200, overflowY: "auto" } }}
      {...props}
      comboboxProps={comboboxProps}
    />
  );
};

export default Select;
